import React, { Component } from "react";
import {
  Dialog,
  DialogHeader,
  DialogFooter,
  DialogFooterButton
} from "@cdk-uip/react-dialog";

export default class SuspendUserDialog extends Component {
  constructor(props) {
    super(props);
    this.suspendUser = this.suspendUser.bind(this);
  }

  suspendUser(e) {
    this.props.suspendUser(this.props.userId, this.props.email);
    this.props.onClose(e);
  }

  render() {
    const { open, onClose, userName, uid } = this.props;
    return (
      <Dialog open={open} onCancel={onClose}>
        <DialogHeader>
          Are you sure you want to suspend user account of {userName} ?
        </DialogHeader>
        <DialogFooter>
          <DialogFooterButton onClick={e => this.suspendUser(e)}>
            Yes
          </DialogFooterButton>
          <DialogFooterButton onClick={onClose}>No</DialogFooterButton>
        </DialogFooter>
      </Dialog>
    );
  }
}
